import React, {Suspense, useCallback, useContext, useEffect} from "react"
import {BrowserRouter as Router, Routes} from "react-router-dom"

import Box from "@mui/material/Box"

import "./App.css"
import "./Styles.css"
import "./styles/global.css"
import moment from "moment-timezone"
import {SnackbarProvider} from "notistack"

import NdToast from "src/components/common/NdComponents/NdToast"
import {useKeyCloakLogout} from "src/utils/KeyCloakUtils"

import {DocoonBroaCastChanel} from "./components/common/BoradCastChanel"
import Sidebar from "./components/layout/SideMenu/SideMenu"
import ErrorContext from "./context/ErrorContext"
import AuthKeyCloak from "./utils/AuthKeyCloak"
import CommonUtils from "./utils/Common"
import Loader from "./utils/Loader"
import Routing from "./utils/Routing"

function App() {
    const context = useContext(ErrorContext)
    const location = window.location.href
    const {logout} = useKeyCloakLogout("")

    const isRolled = useCallback(() => CommonUtils.ToBoolean(CommonUtils.GetLocal("isRoleSelected")), [])

    const resetLocalStorage = useCallback(() => {
        if (!isRolled() && CommonUtils.rightPath(location)) {
            CommonUtils.resetLocalStorage()
        }
    }, [isRolled, location])

    const handleBroadcastMessage = useCallback(async () => {
        try {
            const msg = await DocoonBroaCastChanel()
            context.setGlobalLoading(true)

            switch (msg) {
                case "logout":
                    logout()
                    break
                case "changerole":
                case "Refreshe":
                    CommonUtils.goHome()
                    break
                default:
                    CommonUtils.goHome()
            }
        } catch (error) {
            console.error("Error handling broadcast message:", error)
        }
    }, [context])

    useEffect(() => {
        moment.tz.setDefault("Europe/Paris")
        handleBroadcastMessage()
        resetLocalStorage()
    }, [handleBroadcastMessage, resetLocalStorage])

    return (
        <SnackbarProvider
            anchorOrigin={{
                horizontal: "right",
                vertical: "top"
            }}
            autoHideDuration={10000}
            Components={{
                default: NdToast
            }}
            maxSnack={6}
        >
            <Router>
                <AuthKeyCloak>
                    <Box sx={{display: "flex"}}>
                        {!context.globalLoading && <Sidebar />}
                        <Suspense fallback={<Loader isLoading={true} />}>
                            <Routes>{Routing.CreateRouting()}</Routes>
                        </Suspense>
                    </Box>
                </AuthKeyCloak>
            </Router>
        </SnackbarProvider>
    )
}

export default App
